import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { DialogQoeResultComponent } from './dialog-qoe-result.component';

@Injectable({
    providedIn: 'root'
})
export class DialogQoeResultGridLayoutService implements GridLayoutService<DialogQoeResultComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Entity',            
            field: 'entity',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
            },
            maxWidth: 160,
            flex: 1
        },
        {
            headerName: 'Error Condition',
            field: 'errorDesc',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
            },
            flex: 3        
        }];
    }
}
